import { createFileRoute, isRedirect, redirect } from '@tanstack/react-router'

import { AppLayout } from '@/containers/Layout/App'
import { hikerProfilesQueryOptions } from '@/queries/hiker-profile'
import { userQueryOptions } from '@/queries/user'

export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context: { queryClient } }) => {
    try {
      await queryClient.ensureQueryData(userQueryOptions)
    } catch {
      throw redirect({ to: '/auth/login' })
    }

    try {
      const profiles = await queryClient.ensureQueryData(
        hikerProfilesQueryOptions
      )
      if (profiles.length === 0) {
        throw redirect({ to: '/onboarding' })
      }
    } catch (err) {
      if (isRedirect(err)) throw err
    }
  },
  component: AppLayout,
})
